// MEALUP encyclopedia articles: reading progress bar, contents box built from the H2s, scroll reveal,
// count-up for stat boxes and a swipe hint on wide tables.
(function () {
  const body = document.querySelector('.mu-article .article-template__content');
  if (!body) return;
  document.documentElement.classList.add('mu-ency-js');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // progress bar
  const bar = document.createElement('div');
  bar.className = 'mu-ency-progress';
  bar.innerHTML = '<span></span>';
  document.body.appendChild(bar);
  const fill = bar.firstChild;
  const onScroll = () => {
    const r = body.getBoundingClientRect();
    const total = r.height - window.innerHeight * 0.6;
    const p = Math.min(1, Math.max(0, -r.top / (total > 0 ? total : 1)));
    fill.style.transform = 'scaleX(' + p.toFixed(3) + ')';
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // contents box after the "Накратко" box (or after the lead)
  const heads = [...body.querySelectorAll('h2')].filter((h) => !/^(източници|sources)$/i.test(h.textContent.trim()));
  if (heads.length >= 3) {
    const label = body.dataset.tocLabel || 'Съдържание';
    const toc = document.createElement('details');
    toc.className = 'mu-ency-toc';
    if (window.innerWidth >= 990) toc.open = true;
    const ol = document.createElement('ol');
    heads.forEach((h, i) => {
      if (!h.id) h.id = 'razdel-' + (i + 1);
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      ol.appendChild(li);
    });
    toc.innerHTML = '<summary>' + label + '</summary>';
    toc.appendChild(ol);
    const after = body.querySelector('.mu-ency-tldr') || body.querySelector('.mu-ency-lead');
    if (after) after.after(toc);
  }

  // wide tables: show the swipe hint only when they really scroll
  body.querySelectorAll('.mu-ency-tablewrap').forEach((w) => {
    const check = () => w.classList.toggle('is-scrollable', w.scrollWidth > w.clientWidth + 4);
    check();
    window.addEventListener('resize', check, { passive: true });
    w.addEventListener('scroll', () => { if (w.scrollLeft > 20) w.classList.remove('is-scrollable'); }, { passive: true });
  });

  if (reduce || !('IntersectionObserver' in window)) return;

  // reveal blocks and count up stat numbers
  const count = (el) => {
    const text = el.textContent;
    const m = text.match(/\d+(?:[.,]\d+)?/);
    if (!m) return;
    const dec = (m[0].split(/[.,]/)[1] || '').length;
    const target = parseFloat(m[0].replace(',', '.'));
    const t0 = performance.now();
    const step = (t) => {
      const k = Math.min(1, (t - t0) / 1100);
      const e = 1 - Math.pow(1 - k, 3);
      const v = dec ? (target * e).toFixed(dec).replace('.', m[0].includes(',') ? ',' : '.') : String(Math.round(target * e));
      el.textContent = text.replace(m[0], v);
      if (k < 1) requestAnimationFrame(step);
      else el.textContent = text;
    };
    requestAnimationFrame(step);
  };
  const io = new IntersectionObserver((entries) => {
    entries.forEach((en) => {
      if (!en.isIntersecting) return;
      en.target.classList.add('is-in');
      const num = en.target.querySelector('.mu-ency-stat__num');
      if (num) count(num);
      io.unobserve(en.target);
    });
  }, { rootMargin: '0px 0px -12% 0px' });
  body.querySelectorAll('.mu-ency-stat, .mu-ency-callout, .mu-ency-fig, .mu-ency-steps, .mu-ency-tablewrap, .mu-ency-tldr').forEach((el) => {
    if (el.getBoundingClientRect().top < window.innerHeight) return;
    el.classList.add('mu-ency-rv');
    io.observe(el);
  });
})();
